<div>
    <!-- <div class="font-body-2 text-dat-grey-500">Timeframe: 30 Day | With DAT fuel surcharge (${{ fuelSurcharge() }})</div>
 -->
    <span class="title-large-strong">State</span>
        <button
            class="
                flex
                items-center
                gap-1
                font-button-strong
                !font-bold
                text-dat-blue-500
                bg-transparent
                cursor-pointer
                p-0
                py-[10px]
            "
            data-testid="iq-state-matrix-download-state-spot"
            (click)="clickedDownloadLink('STATE', 'BROKER_TO_CARRIER_SPOT')"
        >
            Spot
            <span data-uitype="md-icon" class="icon-filled material-symbols-outlined w-4 h-4 text-base leading-4">download_2</span>
        </button>

        <button
            class="
                flex
                items-center
                gap-1
                font-button-strong
                !font-bold
                text-dat-blue-500
                bg-transparent
                cursor-pointer
                p-0
                py-[10px]
                mb-6
            "
            data-testid="iq-state-matrix-download-state-contract"
            (click)="clickedDownloadLink('STATE', 'SHIPPER_TO_CARRIER_CONTRACT')"
        >
        Contract
        <span data-uitype="md-icon" class="icon-filled material-symbols-outlined w-4 h-4 text-base leading-4">download_2</span>
    </button>

    <span class="title-large-strong">Regional</span>
        <button
            class="
                flex
                items-center
                gap-1
                font-button-strong
                !font-bold
                text-dat-blue-500
                bg-transparent
                cursor-pointer
                p-0
                py-[10px]
            "
            data-testid="iq-state-matrix-download-region-spot"
            (click)="clickedDownloadLink('REGION', 'BROKER_TO_CARRIER_SPOT')"
        >
        Spot
        <span data-uitype="md-icon" class="icon-filled material-symbols-outlined w-4 h-4 text-base leading-4">download_2</span>
        </button>

        <button
            class="
                flex
                items-center
                gap-1
                font-button-strong
                !font-bold
                text-dat-blue-500
                bg-transparent
                cursor-pointer
                p-0
                py-[10px]
            "
            data-testid="iq-state-matrix-download-region-contract"
            (click)="clickedDownloadLink('REGION', 'SHIPPER_TO_CARRIER_CONTRACT')"
        >
        Contract
        <span data-uitype="md-icon" class="icon-filled material-symbols-outlined w-4 h-4 text-base leading-4">download_2</span>
        </button>

    </div>